/**
 * Checks if the given data is "blank". The following are considered blank:
 * - undefined
 * - null
 * - empty string
 * - empty object
 * - empty array
 * Returns true if blank, and false otherwise.
 * @param {*} data - The data to be checked for a "blank" value
 */
const isBlank = (data) =>
  typeof data === 'undefined' ||
  data === null ||
  (typeof data === 'string' && data.trim() === '') ||
  (Array.isArray(data) && data.length < 1) ||
  (typeof data === 'object' && Object.keys(data).length < 1);

export default isBlank;
